module.exports = __webpack_public_path__ + "img/icon-add.73defb4a.svg";